import gsap from 'gsap';
let isOpen = false;
const MobileNav = {
  btns:null,
  nav:null,
  init() {
    this.btns = document.querySelectorAll('.js-nav-toggle');
    this.nav = document.querySelector('.l-nav');
    if (this.btns.length) {
      this.btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          isOpen = this.toggleNav(isOpen);
        });
      });
    }
  },
  toggleNav(isOpen) {
    if (isOpen) {
      document.body.classList.remove('is-fixed');
      this.btns.forEach((btn) => {
        btn.classList.remove('is-close');
      });
      gsap.to(this.nav, {
        duration: 0.2,
        autoAlpha: 0,
      });
      return false;
    } else {
      document.body.classList.add('is-fixed');
      this.btns.forEach((btn) => {
        btn.classList.add('is-close');
      });
      gsap.to(this.nav, {
        duration: 0.2,
        autoAlpha: 1,
      });
      return true;
    }
  },
};

export { MobileNav };
